// extracted by mini-css-extract-plugin
export default {"back":"styles_back__Y9P09"};